
function getLocalHour(date) {
    if (!date || !date?.getTime) {
        return date;
    }
    // Format the Date object back to "Jan 01"
    const options = {
        hour: 'numeric',   // Numeric hours (e.g., 1, 2, 3)
        minute: '2-digit', // Always show minutes as two digits        
        hour12: true,
    };
    const formattedTime = date.toLocaleTimeString('en-US', options);
    return parseAndFormatFullDate(date) + ' ' + formattedTime;
}

function getLocalShortHour(date) {
    if (!date || !date?.getTime) {
        return date;
    }
    // Format the Date object back to "Jan 01"
    const options = {
        hour: 'numeric',   // Numeric hours (e.g., 1, 2, 3)
        minute: '2-digit', // Always show minutes as two digits
        hour12: true,
    };
    return date.toLocaleTimeString('en-US', options);
}

function formatFullHour(date) {
    if (!isDate(date)) {
        date = getDatetime(date);        
    }
    if (!date || !date?.getTime) {
        return date;
    }
    // Format the Date object back to "Jan 01"
    const options = {
        hour: 'numeric',   // Numeric hours (e.g., 1, 2, 3)
        minute: '2-digit', // Always show minutes as two digits
        hour12: true,
    };
    const formattedDate = date.toLocaleTimeString('en-US', options);
    return parseAndFormatFullDate(date) + ' ' + formattedDate;
}
function parseAndFormatFullHour(inputDate) {
    // Parse the input date string (yyyy/mm/dd) into a Date object
    const dateParts = inputDate.split('/'); // Split by '/'
    const year = parseInt(dateParts?.[0] || 0, 10); // Extract year
    const month = parseInt(dateParts[1], 10) - 1; // Extract month (0-indexed)
    const day = parseInt(dateParts[2], 10); // Extract day
    const hours = parseInt(dateParts[3], 10); // Extract day
    const date = new Date(year, month, day, hours);
    return formatFullHour(date);
}

function isValidDate(input) {
    // Check if input is a Date object and if it is a valid date
    return input instanceof Date && !isNaN(input.getTime());
}
function parseAndFormatFullDate(inputDate) {
    let date;
    if (isValidDate(inputDate)) {
        date = inputDate;
    } else {
        // Parse the input date string (yyyy/mm/dd) into a Date object
        const dateParts = inputDate.split('/'); // Split by '/'
        const year = parseInt(dateParts?.[0] || 0, 10); // Extract year
        const month = parseInt(dateParts[1], 10) - 1; // Extract month (0-indexed)
        const day = parseInt(dateParts[2], 10); // Extract day
        date = new Date(year, month, day);
    }
    // Format the Date object back to "Jan 01"
    const options = { month: 'short', day: '2-digit' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
}
function getLabel(intervalName, label) {
    if (intervalName === 'day') {
        return parseAndFormatFullDate(label);
    }
    return parseAndFormatFullHour(label);
}

const getDate = (pTime, groupByInterval = 'day') => {
    if (groupByInterval === 'day') {
        return `${pTime.getFullYear()}/${(pTime.getMonth() + 1)}/${pTime.getDate()}`;
    }
    if (groupByInterval === 'hour') {
        return `${pTime.getFullYear()}/${(pTime.getMonth() + 1)}/${pTime.getDate()}/${pTime.getHours()}`;
    }
}


function getDatesBetween(startDate, endDate) {
    const start = cloneDatetTime(startDate);
    const end = cloneDatetTime(endDate);
    if (isNaN(start) || isNaN(end) || start > end) {
        return [];
    }
    const dates = [];
    while (start.getTime() <= end.getTime()) {
        const parsedTimestamp = cloneDatetTime(start);
        const item = {
            label: `${parsedTimestamp.getFullYear()}/${(parsedTimestamp.getMonth() + 1)}/${parsedTimestamp.getDate()}`,
            date: parsedTimestamp
        }
        dates.push(item); // Add a copy of the current date
        start.setDate(start.getDate() + 1); // Move to the next day
    }
    return dates;
}
function getHoursBetween(startDate, endDate) {
    const start = cloneDatetTime(startDate);
    const end = cloneDatetTime(endDate);
    if (isNaN(start) || isNaN(end) || start > end) {
        return [];
    }
    const hours = [];
    while (start.getTime() <= end.getTime()) {
        const parsedTimestamp = cloneDatetTime(start);
        const item = {
            label: `${parsedTimestamp.getFullYear()}/${(parsedTimestamp.getMonth() + 1)}/${parsedTimestamp.getDate()}/${parsedTimestamp.getHours()}`,
            date: parsedTimestamp
        }
        hours.push(item); // Add a copy of the current date
        start.setHours(start.getHours() + 1); // Move to the next day
    }
    return hours;
}
const normalizeDate = (dateStr) => {
    const [yy, mm, dd, time] = dateStr.split(/[/\s]/); // Split by "/" and " "
    const [hh, mi, ss] = time.split(":"); // Split time part
    const fullYear = parseInt(yy, 10) + 2000; // Convert "yy" to full "yyyy"
    const monthIndex = parseInt(mm, 10) - 1; // JS months are 0-based
    const dateObject = new Date(fullYear, monthIndex, parseInt(dd, 10), parseInt(hh, 10), parseInt(mi, 10), parseInt(ss, 10));
    return dateObject;
}
const getMinTime = (d1, d2 = new Date()) => {
    return d1.getTime() < d2.getTime() ? d1 : d2;
}
const getMaxTime = (d1, d2 = new Date()) => {
    return d1.getTime() > d2.getTime() ? d1 : d2;
}
const getDatetime = (input) => {
    const temp = typeof input === 'string' ? new Date(input) : input;
    return temp;
}
const isDate = (input) => {
    // Check if input is a Date object and if it's a valid date
    return input instanceof Date && !isNaN(input);
}
const getPstTime = (input) => {
    const temp = typeof input === 'string' ? new Date(input) : input;
    return new Date(temp?.getTime() - (7 * 60 * 60 * 1000));
}
function addDays(date, dateDiff) {
    const givenDate = new Date(date);
    givenDate.setDate(givenDate.getDate() + dateDiff);
    return givenDate;
}
function addHours(date, hourDiff) {
    const givenDate = typeof date === 'string' ? new Date(date) : date;
    givenDate.setHours(givenDate.getHours() + hourDiff);
    return givenDate;
}
function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}
function startOfDay(date) {
    return new Date(date.setHours(0, 0, 0, 0));
}
function endOfDay(date) {
    return new Date(date.setHours(23, 59, 59, 999));
}
function cloneDatetTime(d) {
    return new Date(d.getTime());
}


function getDayName(date) {
    return new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

module.exports = {
    parseAndFormatFullDate,
    parseAndFormatFullHour,
    getDatesBetween,
    getHoursBetween,
    getDate,
    getLabel,
    formatFullHour,
    normalizeDate,
    addDays,
    getPstTime,
    addHours,
    endOfDay,
    startOfDay,
    addMinutes,
    getMinTime,
    cloneDatetTime,
    getLocalHour,
    getMaxTime,
    getDayName,
    getLocalShortHour,
    getDatetime,
    isDate
}